import React, { useEffect, useState  } from "react";
import { commonPostApi } from "../../../utils/apiService";
import {
  generateColumnMetadata,
  orderObj,
} from "../../../utils/utils";
import DataGrid from '../../../components/common/dataGrid/dataGrid';
import { useSelector } from "react-redux";
import { SORT_ORDER } from "../../../constants/sortOrder";
import { AllResourceListColumns } from "../../../utils/serviceData";

export default function AllResource({
  api,
  dashboardApi,
  selectable = false,
  search="",
  roleId,
  setResourceDashboard,
  parentSetProducts,
  parentSetValues,
  parentSetNavigator
}) {
  const [values, setValues] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const id = useSelector(state=> state.common.camp?.camp_details_id);
  const [navigator, setNavigator] = useState({
    page: 1,
    first: 0,
    rows: 10,
    totalRecords: 1,
    sortBy: "user_name",
    sortDir: SORT_ORDER.ASC,
    app_role_id:roleId
  });
  const init = async (navigator) => {
    const query = {
      page: navigator?.page,
      limit:navigator?.rows,
      searchValue:navigator?.searchValue,
      sortFields: navigator?.sortFields,
      app_role_id:navigator?.app_role_id
    };
    const dashboardQuery = {
      searchValue:navigator?.searchValue,
    };
    let headers = {
      "Content-Type": "application/json",
    };
    let orderArray = [
      "user_name",
      "user_code",
      "phone_no"
    ];
    setLoading(true);
    Promise.all([
      await commonPostApi(api, query, {
        headers,
      }),
      await commonPostApi(dashboardApi, dashboardQuery, {
        headers,
      }),
    ])
    .then(async ([ data = {},resource=[]]) => {
      const rows = data?.data?.data?.rows || [];
      const total = data?.data?.data?.total || 0;
      const currentPage = data?.data?.data?.currentPage || 1;
      const resourceList = resource?.data?.data?.map(resource => ({
        ...resource,
        role_name: resource?.role_name === "total" ? "total resources" : resource?.role_name
      }));
      setResourceDashboard(resourceList);
      if (rows) {
        const finalData = rows
        setNavigator((prev) => {
          const updated = {
          ...prev,
          totalRecords:total,
          page:currentPage,
        }
        parentSetNavigator(updated)
          return updated;
      });
       const orderedProducts= orderObj(
            orderArray,
            generateColumnMetadata({
              data: finalData,
              alias: {
                user_code: "user_code",
                phone_no: "phone_no",
              },
              defaultColumnsArr:AllResourceListColumns
            })?.filter((item) => orderArray?.includes(item?.name))
          )
        setColumns(orderedProducts);
        setValues(finalData);

        parentSetProducts(orderedProducts);
        parentSetValues(finalData);
        setLoading(false);
      } 
      else {
        setNavigator((prev) => ({
          ...prev,
          totalRecords: 1,
          page: 1,
        }));
      }
    })
    .catch((err) => {
      console.log(err);
    });
  };
  function onPageChange(event) {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      first: event?.first,
      page: event.page + 1,
    }));
    init({
      ...navigator,
      first: event?.first,
      page: event.page + 1,
    });
  }

  const onRowCountChange = (e) => {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      rows: e?.target?.value,
      page: 1,
      first: 0,
    }));
    init({
      ...navigator,
      page: 1,
      first: 0,
      rows: e?.target?.value,
    });
  };

  useEffect(() => {
    setNavigator((prev) => ({
      ...prev,
      searchValue: search,
    }));
    init({
      ...navigator,
      searchValue: search,
    });
  }, [id,search]);
 

  const onSortClick = (event) => {
    setLoading(true);
    const sortOrder = event?.sortOrder === 1 ? SORT_ORDER.ASC : SORT_ORDER.DESC;
    setNavigator((prev) => ({
      ...prev,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    }));
    init({
      ...navigator,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    });
  };

  return (
    <div>
      <DataGrid
        selectable={selectable}
        onRowCountChange={onRowCountChange}
        onPageChange={onPageChange}
        onSortClick={onSortClick}
        navigator={navigator}
        column={columns}
        value={values}
        loading={loading}
        isAccordionEnabled={false}
        isPaginatorEnabled={true}
        sortable
      />
    </div>
  );
}
